export enum OverallCategoryEnum {
    MUNICIPALITIES_AND_REGIONS = "MUNICIPALITIES_AND_REGIONS",
    IT_VENDOR = "IT_VENDOR",
    OTHER_PARTIES = "OTHER_PARTIES"
}